import request from '@/utils/request'
export function fetchList(params) {
  return request({
    url:'/juanzeng/list',
    method:'get',
    params:params
  })
}
export function createJuanzeng(data) {
  return request({
    url:'/juanzeng/create',
    method:'post',
    data:data
  })
}
export function updateVerifyStatus(params) {
  return request({
    url:'/juanzeng/update/verifyStatus',
    method:'post',
    params:params
  })
}
export function updateVerifyStatusForArticle(params) {
  return request({
    url:'/juanzeng/update/verifyStatusForArticle',
    method:'post',
    params:params
  })
}
export function deleteJuanzengs(params) {
  return request({
    url:'/juanzeng/delete/batch',
    method:'post',
    params:params
  })
}
export function deleteJuanzeng(id) {
  return request({
    url:'/juanzeng/delete/'+id,
    method:'get',
  })
}
export function deleteJuanzengSAndArticle(params) {
  return request({
    url:'/juanzeng/delete/article/batch',
    method:'post',
    params:params
  })
}
export function deleteJuanzengAndArticle(id) {
  return request({
    url:'/juanzeng/delete/article/'+id,
    method:'get',
  })
}
export function getJuanzeng(id) {
  return request({
    url:'/juanzeng/'+id,
    method:'get',
  })
}
export function getJuanzengArticle(id) {
  return request({
    url:'/juanzeng/article/'+id,
    method:'get',
  })
}
export function updateJuanzeng(id,data) {
  return request({
    url:'/juanzeng/update/'+id,
    method:'post',
    data:data
  })
}




// WEBPACK FOOTER //
// ./src/api/juanzeng.js